import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    APIS,
    SF_APP_DTL_VRFN_INFO,
    SF_APP_RGST_VRFN_RSLT,
} from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";

export const OSCI0201019S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0006", "auth_osci0015"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { close, postMessage, getParams } = usePopup();
    const params = getParams(); // 부모창에서 전달된 Parameter

    let errmsg: any;

    const [sbmtVisible, setSbmtVisible] = useState(false);
    const [excludeAuditCode, setExcludeAuditCode] = useState<any[]>(["FV", "IP", "AP", "RS"]);

    const [aprvExisYn, setAprvExisYn] = useState("N");
    const [aprvTargetStat, setAprvTargetStat] = useState<string[]>([]);

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0131" }],
    });

    const form = {
        appDtlVrfnInfo: useForm({
            defaultSchema: SF_APP_DTL_VRFN_INFO,
        }),
        appRgstVrfnRslt: useForm({
            defaultSchema: SF_APP_RGST_VRFN_RSLT,
        }),
        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O",
                bsopClsfCd: "OSC",
                // Approval review screen 030Q (cancel/amendment) !== 결재 검토화면 030Q (취소/정정) ==!
                scrnDocCd: params.appInfo.amdTpCd === "C" ? "scrn_osca0003" : "scrn_osca0002",
                aprvReffId: "/" + params.appInfo.appId,
                docNo: params.appInfo.appNo, // Application number as document number !== 문서 번호로 신청서 번호 사용 ==!
                aprvAfPrcssCfgnId: "cfgn_osc0005",
                cnclAfPrcssCfgnId: "cfgn_osc0007",
                rtrnAfPrcssCfgnId: "cfgn_osc0008",
                prevStageRtrnUseYn: "Y",
                itsfAprvYn: "N",
                rjctStatUseYn: "N",
                grpAprvYn: "N",
            },
        }),
    };

    /*
     * Application Item Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppAprvInfo: useFetch({
            api: (data) => APIS.getAppAprvInfo({ reffId: data.appId }),
            onSuccess: (data) => {
                if (data.appAprvInfo!) {
                    form.appRgstVrfnRslt.setValues(data.appAprvInfo.content);
                    if (data.appAprvInfo.content.prcssStatCd!) {
                        setSbmtVisible(true);
                    }
                }
                const prcsRoleTpCd = data?.prcsInfo?.content?.prcsRoleTpCd || "";
                const prevPrcsRoleTpCd = data?.prcsInfo?.content?.prevPrcsRoleTpCd || "";
                setExcludeAuditCode([
                    ...APIS.getExcludeAuditRsltCdList(prcsRoleTpCd, prevPrcsRoleTpCd, params.appInfo.appCdNo),
                ]);

                if (data?.appAprvInfo?.content?.aprvId) {
                    form.aprvRqstForm.setValue("aprvId", data?.appAprvInfo?.content?.aprvId);
                }
                // 결재 존재 여부
                const aprvExisYn = data?.prcsInfo?.content?.aprvExisYn || "N";
                setAprvExisYn(aprvExisYn);

                // Approval-gating target result states, from backend !== 전자결재 대상 결과 상태집합(백엔드 수신) ==!
                setAprvTargetStat(data?.prcsInfo?.content?.aprvTargetStatList || []);
            },
            onError: (error) => {
                errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        saveAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.saveAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        handler.setInit();
                        modal.postMessage({ rslt: "save" });
                    },
                    onClose: () => {
                        handler.setInit();
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        sbmtAppAprvRslt: useFetch({
            api: (data) => {
                return APIS.sbmtAppAprvRslt({ ...data });
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                });
            },
            onError: (error) => {
                const errmsg = error.response.data.errorCode == -1 ? "msg.osc.00015" : error.response.data.errorMessage;

                modal.openModal({
                    content: errmsg,
                });
            },
        }),
        rqstAprvRslt: useFetch({
            api: (data) => APIS.rqstAprvRslt({ ...data }),
            onSuccess: () => {
                // Close the approval popup only on success; on failure it stays open !== 결재 팝업은 성공 시에만 닫고 실패 시 유지 ==!
                modal.closeModal("OgaAprvRqst");
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                    onClose: () => {
                        modal.postMessage({ rslt: "sbmt" });
                    },
                });
            },
            onError: (error) => {
                // No response (network error, server restart) also shows the default error !== 응답이 없는 경우(네트워크 오류, 서버 재기동)도 기본 오류 메시지 표시 ==!
                const errmsg =
                    !error.response?.data?.errorMessage || error.response.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response.data.errorMessage;
                modal.openModal({ content: errmsg });
            },
        }),
    };

    /*
     * Application Item Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await form.appDtlVrfnInfo.setValues(params.appInfo);
            await handler.getAppAprvInfo();
        },
        getAppAprvInfo: async () => {
            fetch.getAppAprvInfo.fetch(params.appInfo);
        },
        // Registration validation of application verification results !== 신청서 심사결과 등록 유효성 검사 ==!
        validateRgstVrfnRslt: async (type: any) => {
            const chkRslt = await form.appRgstVrfnRslt.validate();

            if (chkRslt) {
                form.appRgstVrfnRslt.setValue("reffId", params.appInfo.appId);
                const data = { ...form.appRgstVrfnRslt.getValues() };
                data.amdTpCd = params.appInfo.amdTpCd;
                data.orgCd = auth.get("orgCd");

                if (type == "save") {
                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            fetch.saveAppAprvRslt.fetch(data);
                        },
                    });
                } else if (type == "sbmt") {
                    modal.openModal({
                        content: "msg.osc.00092",
                        onConfirm: () => {
                            // Check approval existence and processing status !== 결재를 해야하고 대상 결과 상태일 경우 결재 팝업 표시 ==!
                            if (aprvExisYn == "Y" && aprvTargetStat.includes(data.prcssStatCd)) {
                                handler.openAprvRqstPopup();
                            } else {
                                fetch.sbmtAppAprvRslt.fetch(data);
                            }
                        },
                    });
                }
            }
        },
        openAprvRqstPopup: () => {
            modal.openModal({
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "OSC",
                            scrnDocCd: params.appInfo.amdTpCd === "C" ? "scrn_osca0003" : "scrn_osca0002",
                            aprvId: form.aprvRqstForm.getValue("aprvId"),
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });
                                const param = {
                                    ...form.appRgstVrfnRslt.getValues(),
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                // Return the request so the popup can disable its button; popup is closed in onSuccess !== 팝업 버튼 비활성을 위해 요청을 반환, 팝업은 onSuccess에서 닫음 ==!
                                return fetch.rqstAprvRslt.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_VRFN_RSLT"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlVrfnInfo.schema.appNo} />
                                <Group.Control {...form.appDtlVrfnInfo.schema.ucrNo} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlVrfnInfo.schema.appNm} />
                                <Group.Control {...form.appDtlVrfnInfo.schema.sbmtDtm} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control
                                    {...form.appRgstVrfnRslt.schema.prcssStatCd}
                                    controlSize={10}
                                    excludes={[...excludeAuditCode]}
                                />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appRgstVrfnRslt.schema.prcssRsnCn} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appRgstVrfnRslt.schema.rmrk} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>

                    <Layout direction="row">
                        <Layout.Right>
                            <Button
                                role="save"
                                onClick={() => {
                                    handler.validateRgstVrfnRslt("save");
                                }}
                            />
                            {sbmtVisible && (
                                <Button
                                    role="submit"
                                    onClick={() => {
                                        handler.validateRgstVrfnRslt("sbmt");
                                    }}
                                >
                                    {t("L_CFRM")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
